import React from "react";
import TabBar, { TabBarProps } from "../../../../shared/components/TabBar";
import { Provider } from "../../../../data/entities";
import FormContainer from "../Content";
import MaterialList from "../../create/Content/MaterialList";

interface TabNavigationProps {
    validated: boolean;
    providerData: Provider;
    mergeProvider: Function;
}

const TabNavigation = ({
    validated,
    providerData,
    mergeProvider,
}: TabNavigationProps) => {
    const tabs: TabBarProps[] = [
        {
            label: "Thông tin",
            labelEN: "info",
            content: (
                <FormContainer
                    validated={validated}
                    providerData={providerData}
                    mergeProvider={mergeProvider}
                />
            ),
        },
        {
            label: "Vật tư cung cấp",
            labelEN: "select-materials",
            content: (
                <MaterialList
                    providerData={providerData}
                    mergeProvider={mergeProvider}
                />
            ),
        },
        {
            label: "Vật tư gia công",
            labelEN: "outsource-materials",
            content: (
                <MaterialList
                    providerData={providerData}
                    mergeProvider={mergeProvider}
                    relationKey="outsource_materials"
                    title="Danh sách vật tư gia công"
                    counterLabel="vật tư gia công"
                    priceColumnLabel="Giá gia công"
                    addButtonLabel="Thêm vật tư gia công"
                    emptyText="Không có vật tư gia công nào được chọn"
                    searchPlaceholder="Tìm kiếm vật tư gia công..."
                />
            ),
        },
    ];

    return <TabBar tabs={tabs} />;
};

export default TabNavigation;
